"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lenderSchema = exports.lenderAddressSchema = exports.claimPayeeSchema = exports.authorizedOfficerSchema = void 0;
var constants_1 = require("@hobt/constants");
var constants_2 = require("../../constants");
exports.authorizedOfficerSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['emailID', 'firstName', 'lastName', 'phoneNumber', 'positionTypeCode'],
    properties: {
        emailID: {
            type: 'string',
            pattern: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$',
            minLength: 1,
            maxLength: 80,
            errorMessage: {
                maxLength: 'Should be a string with a maximum of 80 characters',
                pattern: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_MUST_BE_A_VALID_EMAIL_FORMAT),
            },
        },
        extensionPhoneNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 7,
            errorMessage: 'Should be a string with 7 characters or null',
        },
        faxNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 10,
            errorMessage: 'Should be a string with 10 characters or null',
        },
        firstName: {
            type: 'string',
            minLength: 1,
            maxLength: 15,
            errorMessage: 'Should be a string with a maximum of 15 characters',
        },
        lastName: {
            type: 'string',
            minLength: 1,
            maxLength: 25,
            errorMessage: 'Should be a string with a maximum of 25 characters',
        },
        phoneNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 10,
            isNotEmpty: true,
            errorMessage: 'Should be a string with 10 characters',
        },
        positionTypeCode: {
            type: 'number',
            enum: Object.values(constants_2.AuthorizedOfficerPosition),
            errorMessage: 'Should equate to a valid AuthorizedOfficerPosition Enum value',
        },
    },
    allOf: [
        {
            if: {
                properties: {
                    phoneNumber: {
                        const: '',
                    },
                },
            },
            else: {
                properties: {
                    phoneNumber: {
                        type: 'string',
                        minLength: 10,
                        maxLength: 10,
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    faxNumber: {
                        enum: ['', null],
                    },
                },
            },
            else: {
                properties: {
                    faxNumber: {
                        type: 'string',
                        minLength: 10,
                        maxLength: 10,
                    },
                },
            },
        },
    ],
};
exports.claimPayeeSchema = {
    type: 'object',
    required: ['payeeID', 'transitNumber', 'typeCode'],
    properties: {
        name: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 35,
            errorMessage: 'Should be a string with a maximum of 35 characters or null',
        },
        payeeID: {
            type: 'number',
            minimum: 0,
            maximum: 2147483647,
            errorMessage: 'Should be an integer between 0 and 2147483647',
        },
        transitNumber: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with 5 characters',
        },
        typeCode: {
            type: 'number',
            enum: Object.values(constants_2.ClaimPayeeType),
            errorMessage: 'Should equate to a valid ClaimPayeeType Enum value',
        },
    },
};
exports.lenderAddressSchema = {
    type: 'object',
    required: ['lineOneText', 'municipalityName', 'postalCode', 'provinceCode'],
    properties: {
        lineOneText: {
            type: 'string',
            minLength: 1,
            maxLength: 90,
            errorMessage: 'Should be a string with a maximum of 90 characters',
        },
        lineTwoText: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 90,
            errorMessage: 'Should be a string with a maximum of 90 characters or null',
        },
        municipalityName: {
            type: 'string',
            minLength: 1,
            maxLength: 20,
            errorMessage: 'Should be a string with a maximum of 20 characters',
        },
        postalCode: {
            type: 'string',
            minLength: 6,
            maxLength: 6,
            errorMessage: 'Should be a valid postal code with 6 characters',
            allOf: [
                {
                    if: {
                        const: '',
                    },
                    else: {
                        required: ['postalCode'],
                        isNotEmpty: true,
                        isValidPostalCode: { $data: '1/provinceCode' },
                    },
                },
            ],
        },
        provinceCode: {
            type: 'string',
            enum: Object.values(constants_1.StatisticsCanadaProvinceID),
            errorMessage: 'Should equate to a valid StatisticsCanadaProvinceID Enum value',
        },
    },
};
exports.lenderSchema = {
    type: 'object',
    required: [
        'address',
        // TODO: Add lender code back in the nearby future
        // 'approvedLenderCode',
        'authorizedOfficers',
        'claimPayee',
        'correspondenceLanguageCode',
    ],
    properties: {
        address: exports.lenderAddressSchema,
        approvedLenderCode: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with 5 characters',
        },
        authorizedOfficers: {
            type: 'array',
            items: exports.authorizedOfficerSchema,
            minItems: 1,
        },
        claimPayee: exports.claimPayeeSchema,
        correspondenceLanguageCode: {
            type: 'number',
            enum: Object.values(constants_1.Language),
            errorMessage: 'Should equate to a valid Language Enum value',
        },
    },
};
